import { emailSchema, phoneRequiredSchemaV2, select2RequiredSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, string } from 'yup';

const addStaffSchemaV2 = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    email: emailSchema,
    phone: phoneRequiredSchemaV2

    // assign_schools: array()
    //     .min(1, "At least one school must be assigned")
    //     .of(
    //         object().shape({
    //             division: select2RequiredSchema,
    //             name: select2RequiredSchema,
    //         })
    //     ),
    // isLoginAllowed: stringRequiredSchema, 

});

export default addStaffSchemaV2;